import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Location = ({ country, city, location }) => {
  const { t } = useTranslation('common')

  return (
    <div className='oglasi-dodatne-informacije'>
      <div className='oglasi-info-heading'>
        <p>{t('Lokacija oglasa')}</p>
      </div>
      <div>
        <ul>
          <li>
            <p>{t('Država')}</p>
            <span>{country}</span>
          </li>
          <li>
            <p>{t('Grad')}</p>
            <span>{city}</span>
          </li>
          <li>
            <p>{t('Lokacija')}</p>
            <span>{location}</span>
          </li>
        </ul>
      </div>
    </div>
  )
}

Location.propTypes = {
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired
}

Location.defaultProps = {
  city: '',
  country: '',
  location: ''
}
